<template>
  <div class="estimateCard">
    <h3 class="title title_order">饲喂程序信息</h3>
    <p class="p_text font_bold">基础信息</p>
    <a-row :gutter="24">
      <a-col :span="8" v-for="(el,index) in feedBaseFeild" :key="index">
        <p class="p_text">{{ el.name }}: {{ infor[el.feild]!==undefined?infor[el.feild]: "-" | filter_isReally}}</p>
      </a-col>
    </a-row>
    <p class="p_text font_bold">饲喂程序</p>
    <a-table
      :columns="columns"
      :data-source="list"
      class="estimateTable"
      :pagination="false"
      row-key="id"
    >
      <template slot="f3" slot-scope="text, record">
        {{record.formulaName}}
        <a style="margin-left: 10px" @click="details(record)">查看</a>
      </template>
    </a-table>
    <formula ref="Formula" />
  </div>
</template>
<script>
import {
  feedBaseFeild,
  feedColumns,
} from "../../EstimateConfig/estimateConfig";
import Formula from "./Formula.vue";
import { mixinsFilter} from "@/Mixins/mixinsData";
export default {
  props: ['detailsA'],
  components: { Formula },
  mixins: [ mixinsFilter],
   
  data() {
    return {
      feedBaseFeild,
      columns: feedColumns,
      infor: {},
      list: [],
    };
  },
   watch:{
    detailsA:{
      handler(data){
        let { pigFeedingProgramInfoVO } = data;
        this.infor = { ...pigFeedingProgramInfoVO };
        this.list=pigFeedingProgramInfoVO.pigFeedingProgramWeightList
      },
      deep:true
    }
  },
  methods: {
    details(records) {
      this.$refs.Formula.init(records);
    },
  },
};
</script>